// extracted by mini-css-extract-plugin
export default {"show-more-button":"YhiG5","showMoreButton":"YhiG5","show-more-button-large":"DtZIK","showMoreButtonLarge":"DtZIK"};